import { render, staticRenderFns } from "./AddNewWishlist.vue?vue&type=template&id=fc17a9ce&scoped=true&"
import script from "./AddNewWishlist.vue?vue&type=script&lang=js&"
export * from "./AddNewWishlist.vue?vue&type=script&lang=js&"
import style0 from "./AddNewWishlist.vue?vue&type=style&index=0&id=fc17a9ce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc17a9ce",
  null
  
)

export default component.exports